import i18n from '@/i18n'

export const humanDate = (date) => {
  return new Date(date).toLocaleString(`${i18n.global.locale.value}-CA`, {
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    month: 'long',
    timeZone: 'America/Montreal',
    weekday: 'long',
  })
}
